import { RouteRecordRaw } from 'vue-router';
import ticketPrenotazione from './ticketPrenotazione.vue';

export default [
    {
        path: '/ticketPrenotazione',
        component: ticketPrenotazione,
        meta: { title: "Ticket Prenotazione"},
    },
];